export enum WorksheetType {
	CabinetMeasure = 1,
	CabinetQualityCheck = 2
};